package navigation.home.travelagents.alltravelagents

import alltravelagents.AllTravelAgentsEvent
import alltravelagents.AllTravelAgentsState
import alltravelagents.AllTravelAgentsViewModel
import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository

class AllTravelAgentsScreenModel(
    travelAgentRepository: TravelAgentRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllTravelAgentsState>(AllTravelAgentsState()) {
    private val allTravelAgentsViewModel =
        AllTravelAgentsViewModel(
            travelAgentRepository = travelAgentRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllTravelAgentsEvent) {
        allTravelAgentsViewModel.onEvent(event)
    }
}
